import React, { useEffect } from 'react'
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import  BreadCrumb  from "app/components/BreadCrumb";
import { AddButton } from 'app/components/Button/AddButton';
import { useTranslation } from "react-i18next";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { actions, reducer, sliceKey } from "./redux/slice";
import { documentSaga } from "./redux/saga"
import { useStyles } from "./styles";
import AdminTemplateTable from "./components/adminTemplateTable"
import AddTemplateModal from "./components/suppliersModal"
import { ScrollableView } from "app/components/ScrollableView";
import {
  selectTemplates,
  selectIsLoading,
} from "./redux/selector";


const AdminTemplate = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();
const dispatch = useDispatch()
const rows = useSelector(selectTemplates)
const loading = useSelector(selectIsLoading) 
useInjectReducer({
  key: sliceKey,
  reducer,
});

useInjectSaga({
  key: sliceKey,
  saga: documentSaga
})

useEffect(() => {
  dispatch(actions.getDocumentList())
}, [dispatch])

// The templates list is not paginated, so there is never a next page to load.
const getNextPage = () => {};

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.DOCUMENT_TEMPLATES")} iconPosition="end" />
            <Box>
              <AddButton label={t(("ADMIN_TEMPLATE.ADD"))} onClick={() => dispatch(actions.openAddModal())}/>
            </Box>
            <Box className={styles.tableContainer}>
              <ScrollableView
                borderless
                height="calc(100vh - 200px)"
                loadMore={getNextPage}
                hasMoreItems={false}
              >
                <AdminTemplateTable
                  rows={rows}
                  loading={loading && rows.length === 0}
                />
              </ScrollableView>
            </Box>
          </Box>
        </Box>
        <AddTemplateModal />
    </Box>
  )
}

export default AdminTemplate
